import { render, staticRenderFns } from "./c-price-range.vue?vue&type=template&id=0b6a54db&"
import script from "./c-price-range.vue?vue&type=script&lang=js&"
export * from "./c-price-range.vue?vue&type=script&lang=js&"
import style0 from "./c-price-range.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports